import { render, staticRenderFns } from "./CampaignStatusTable.vue?vue&type=template&id=990f7f56&"
import script from "./CampaignStatusTable.vue?vue&type=script&lang=ts&"
export * from "./CampaignStatusTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports